export enum ApiUrl {
  FromBaymanager = 1,
  FromLeague = 2,
}
